// extracted by mini-css-extract-plugin
export var darkTheme = "MainStyles-module--darkTheme--7ad09";
export var fullScreen = "MainStyles-module--fullScreen--0b260";
export var injectedMarkdown = "MainStyles-module--injectedMarkdown--9e085";
export var lightTheme = "MainStyles-module--lightTheme--7a4ca";
export var transparentTheme = "MainStyles-module--transparentTheme--f6fa2";